import React from 'react'
import PropTypes from 'prop-types'

const League = ({id, name, photo_url, onEdit}) => {
  const onClickEdit = (e) => {
    e.preventDefault()
    onEdit()
  }

  return <a href={`/admins/leagues/${id}`}>
    <div className='col-xs-12 col-sm-6 col-md-4 col-lg-3'>
      <div className='league-card'>
        <img src={photo_url + '?' + Math.random()} />
        <div className='league-card__content'>
          <div className='league-name' title={name}>{name}</div>
          <button className='leagues-button edit-league clickable' onClick={onClickEdit}>Edit</button>
        </div>
      </div>
    </div>
  </a>
}

League.propTypes = {
  name: PropTypes.string.isRequired,
  photo_url: PropTypes.string.isRequired,
}

export default League
